import { Getters } from 'vuex-smart-module';
import EventsCalendarState from './state';

export default class EventsCalendarGetters extends Getters<EventsCalendarState> { }
